import { ModelBase } from "../shared/model.base";

export class Protocol extends ModelBase {
    id: number;
    name: "";
    active: boolean;

    constructor() {
        super();
    }
}
